import React, { SyntheticEvent, useEffect, useState } from "react";
import "./Faq.scss";
import Loader from "../../components/Loader/Loader";
import { CustomTab, StyledTabs } from "../Help/TermsAndPrivacyPolicy";
import axios, { AxiosResponse } from "axios";
import images from "../../assets/images";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  width: "883px",
  borderRadius: "20px !important",
  display: "flex",
  flexDirection: "column",
  padding: "10px 30px 10px 30px",
  boxSizing: "border-box",
  justifyContent: "space-between",
  boxShadow: "rgba(14, 63, 126, 0.06) 0px 0px 0px 1px, rgba(42, 51, 70, 0.03) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 2px 2px -1px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.03) 0px 5px 5px -2.5px, rgba(42, 51, 70, 0.03) 0px 10px 10px -5px, rgba(42, 51, 70, 0.03) 0px 24px 24px -8px",
}));

const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  width: "100%",
  fontFamily: "Inter",
  fontWeight: "400",
  fontSize: "16px",
  lineHeight: "24.8px",
  color: "#000000",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  fontFamily: "Inter",
  fontWeight: "300",
  fontSize: "16px",
  lineHeight: "24.8px",
  color: "#000000",
  paddingBottom: "50px",
}));

interface AccordionItem {
  title: string;
  answer: string;
  categories: string[];
}

const Faq = () => {
  const katon_cms = process.env.REACT_APP_KATON_CMS_SITE;
  const [loading, setLoading] = useState<boolean>(false);
  const [content, setContent] = useState<AccordionItem[]>([]); // Ensure this is an array
  const [activeTab, setActiveTab] = useState<string>("360 Classroom");
  const { faq, LegalBackIcon } = images;
  const navigate = useNavigate();

  const handleChangeTab = (_e: SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
    setExpandedAccordion(false)
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response: AxiosResponse<AccordionItem[]> = await axios.get(
          `${katon_cms}/classroom_faqs`,
          {
            headers: {
              "X-Hash-Key": process.env.REACT_APP_KATON_SITE_API_KEY,
            },
          }
        );
        setContent(response.data); // Response data should be an array of AccordionItem
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [katon_cms]);

  const [expandedAccordion, setExpandedAccordion] = useState<string | false>(
    false
  );

  const handleExpandClick = (panelId: string) => (event: React.MouseEvent) => {
    event.stopPropagation();
    setExpandedAccordion(expandedAccordion === panelId ? false : panelId);
  };

  // Filter data based on the selected tab
  const filteredData = content.filter((item) =>
    item.categories.includes(activeTab)
  );

  const handleBackIcon = () => {
    navigate('/');
  }

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="faq-container">
          <div className="title">
            <div className="faqHeadingContainer">
                <img alt="backIcon" src={LegalBackIcon} className="faqBackIconStyle" onClick={handleBackIcon}/>
                <div className="heading">Frequently asked Questions</div>
            </div>
            <div className="picture">
              <img src={faq} alt="legal" />
            </div>
          </div>
          <StyledTabs value={activeTab} onChange={handleChangeTab} className="faqTabsContainer">
            <CustomTab label={"360 Classroom"} value="360 Classroom" className="Classroom360TabStyle"/>
            <CustomTab label={"TLMS Global"} value="TLMS Global" className="tlmsGlobalTabStyle"/>
            <CustomTab label={"Katon Network"} value="Katon Network" className="katonNetworkTabStyle"/>
          </StyledTabs>
          <div className="faq-content">
            {filteredData.reverse().map((item, index) => (
              <StyledAccordion    
                slotProps={{
                  transition : {
                    timeout : 100,
                    easing: "ease-in-out",
                  }
                }}
                expanded={expandedAccordion === `panel${index}`}
                key={index}
                className="styledAccordion"
              >
                <StyledAccordionSummary
                  className="styledAccordionSummary"
                  aria-controls={`panel${index}-content`}
                  id={`panel${index}-header`}
                  onClick={handleExpandClick(`panel${index}`)}
                  // onClick={(event) => event.preventDefault()}
                  
                >
                  <span dangerouslySetInnerHTML={{ __html: item.title }} />
                  <IconButton
                    onClick={handleExpandClick(`panel${index}`)}
                    sx={{
                      cursor: 'pointer'
                    }}
                    disableRipple
                     // Toggle only when the expand icon is clicked
                  >
                    <ExpandMoreIcon />
                  </IconButton>
                </StyledAccordionSummary>
                <StyledAccordionDetails>{item.answer}</StyledAccordionDetails>
              </StyledAccordion>
            ))}
            <div className="write-us">
              <span className="heading">write us</span>
              <span className="sub-heading">
                Can't find your answer in the FAQ? Ask us directly.
              </span>
              <a href="mailto:help@katon360.com" className="mail">help@katon360.com</a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Faq;
